import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG_empty.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import { PresetColors } from "./LeftSidebar/EditTab";
import { useTranslation } from "react-i18next";
import { getOneLetterResult } from "../../../../frontend/templates/fcb/MatchdaySlider/Index";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";

const FCBSlider1Content = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;

    const { options, fields, dynamic, editData } = data.data;
    const {
        awayLastGames,
        homeLastGames,
        totalScores
    } = data?.data?.dynamic;

    const homeTeam = data?.event?.home;
    const awayTeam = data?.event?.away;
    let statsLeftTeam = homeTeam;
    let statsRightTeam = awayTeam;
    if (statsRightTeam.shortcut == 'FCB') {
        statsLeftTeam = awayTeam;
        statsRightTeam = homeTeam;
    }

    const competitionId = data?.event?.competitionId;

    const date = data?.event?.date;
    const time = data?.event?.time;
    const [day, month, year] = date.split(".");
    const dateTimeString = `${year}-${month}-${day}T${time}`;
    const customBackground = getContentById("background", fields, "self");
    const homeWins = totalScores?.homeWins || 0;
    const homeDraws = totalScores?.homeDraws || 0;
    const homeLoss = totalScores?.homeLoss || 0;

    let numberOfWins = homeWins
    let numberOfDraws = homeDraws
    let numberOfLosses = homeLoss;
    if (isNaN(numberOfWins)) {
        numberOfWins = 0;
    }
    if (isNaN(numberOfDraws)) {
        numberOfDraws = 0;
    }
    if (isNaN(numberOfLosses)) {
        numberOfLosses = 0;
    }

    const { t } = useTranslation();
    const selectedLang = data?.lang;

    return (
        <div id={id} className="T_fcb_matchday_slider_1" style={{ zIndex: 101, }}>
            <div className={"wc-content wc-content-v2"}
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white'
                }}
            >
                <div className="first-bottom-container">
                    <div className={`${selectedLang === 'ar' ? 'logo-container-ar' : 'logo-container'}`}>
                        <div className="label-match-info-glow">
                            {t("Match Info", { keyPrefix: "table", lng: selectedLang })}
                        </div>
                        <div className="label-match-info">
                            {t("Match Info", { keyPrefix: "table", lng: selectedLang })}
                        </div>
                    </div>
                    <div className={`last-games`}>
                        <div className={`left-circles`}>
                            <div className={`arrow-right`}></div>
                            {homeLastGames?.map((result) => {
                                const out = getOneLetterResult(result, "home", selectedLang);
                                return <div className={"circle"}>{out}</div>;
                            })}
                        </div>

                        <div className="home-away-container">
                            <div className={`home`}>
                                <TeamLogo team={homeTeam} competitionId={competitionId} />
                            </div>

                            <div className={`away`}>
                                <TeamLogo team={awayTeam} competitionId={competitionId} />
                            </div>
                        </div>

                        <div className={`right-circles`}>
                            <div className={`arrow-left`}></div>
                            {awayLastGames?.map((result) => {
                                const out = getOneLetterResult(result, "away", selectedLang);
                                return <div className={"circle"}>{out}</div>;
                            })}
                        </div>
                    </div>
                </div>
                <div className="gradient"></div>
            </div>

        </div>

    );
};

export default FCBSlider1Content;
